import type * as Types from 'app/types/graphql';

import { PlatformProductSelectFragmentDoc } from '../fragments/platformProduct.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type PlatformProductsQueryVariables = Types.Exact<{
  parameter: Types.PlatformProductQueryParameter;
  platform: Types.Platform;
}>;

export type PlatformProductsQueryResponse = {
  platformProducts: {
    edges?: Types.Maybe<
      Array<
        Types.Maybe<
          Pick<Types.PlatformProductEdge, 'cursor'> & {
            node?: Types.Maybe<
              Pick<
                Types.PlatformProduct,
                | 'id'
                | 'baseID'
                | 'handle'
                | 'title'
                | 'image'
                | 'status'
                | 'onlineStoreURL'
                | 'publishedAt'
                | 'templateSuffix'
              >
            >;
          }
        >
      >
    >;
    pageInfo?: Types.Maybe<Pick<Types.PageInfo, 'hasNextPage' | 'endCursor'>>;
  };
};

export const PlatformProductsDocument = `
    query PlatformProducts($parameter: PlatformProductQueryParameter!, $platform: Platform!) {
  platformProducts(parameter: $parameter, platform: $platform) {
    edges {
      cursor
      node {
        ...PlatformProductSelect
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${PlatformProductSelectFragmentDoc}`;

export const usePlatformProductsQuery = <TData = PlatformProductsQueryResponse, TError = unknown>(
  variables: PlatformProductsQueryVariables,
  options?: UseQueryOptions<PlatformProductsQueryResponse, TError, TData>,
) => {
  return useQuery<PlatformProductsQueryResponse, TError, TData>(
    ['PlatformProducts', variables],
    appFetcher<PlatformProductsQueryResponse, PlatformProductsQueryVariables>(
      PlatformProductsDocument,
      variables,
    ),
    options,
  );
};

usePlatformProductsQuery.getKey = (variables: PlatformProductsQueryVariables) => [
  'PlatformProducts',
  variables,
];
